import { css } from '@emotion/react'

const useFormStyles = () => {
  const placeholderStyle = css`
    &::-webkit-input-placeholder {
      color: #b3b3b3;
    }

    &::-moz-placeholder {
      color: #b3b3b3;
      opacity: 1;
    }

    &:-ms-input-placeholder {
      color: #b3b3b3;
    }

    &:placeholder-shown {
      color: #b3b3b3;
    }
  `

  return { placeholderStyle }
}

export default useFormStyles
